import { COMPANY } from "../../lib/data";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#18181B] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="logo" className="h-12 w-auto" />
              <span className="font-display font-extrabold text-xl tracking-tight">POOJA PAINTING WORK</span>
            </div>
            <p className="text-zinc-400 max-w-sm leading-relaxed">
              Premier industrial painting & coatings contractor with {COMPANY.experience}+ years of
              hands-on experience serving India&apos;s leading cement and infrastructure firms.
            </p>
            <p className="overline text-amber-400 mt-6">{COMPANY.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="overline text-zinc-500 mb-5">Navigate</h4>
            <ul className="space-y-3 text-zinc-300">
              {["Services", "Our Work", "Clients", "Why Us", "Contact"].map((l) => (
                <li key={l}>
                  <a href={`#${l.toLowerCase().replace(/\s/g, "")}`} className="hover:text-accent transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="overline text-zinc-500 mb-5">Get in touch</h4>
            <ul className="space-y-4 text-zinc-300 text-sm">
              {COMPANY.phones.map((p) => (
                <li key={p} className="flex items-center gap-3"><Phone className="w-4 h-4 text-accent shrink-0" /> {p}</li>
              ))}
              {COMPANY.emails.map((e) => (
                <li key={e} className="flex items-center gap-3"><Mail className="w-4 h-4 text-accent shrink-0" /> {e}</li>
              ))}
              <li className="flex items-center gap-3"><Globe className="w-4 h-4 text-accent shrink-0" /> {COMPANY.website}</li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-accent shrink-0 mt-1" /> {COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-16 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-sm text-zinc-500">
          <span>&copy; {new Date().getFullYear()} Pooja Painting Work. All rights reserved.</span>
          <span className="font-mono-a">GSTIN: {COMPANY.gstin}</span>
        </div>
      </div>
    </footer>
  );
};
